!((document, Drupal, $, once) => {
  'use strict';

  /**
   * Set and update the hero image sidebar height.
   */
  Drupal.behaviors.heroImageSidebar = {
    attach: context => {
      /**
       * Calculate and set sidebar height based on related units.
       * @param {jQuery} $sidebar The sidebar to resize.
       * @return {undefined}
       */
      function setHeight($sidebar) {
        if ($(window).width() > 991) {
          // Move the sidebar into position for large screen viewport.
          $sidebar.prependTo('.js-hero-image-sidebar-wrapper--large');

          // Main content column.
          var $main = $('.js-hero-image-sidebar-main');

          // Reset any previously set height.
          $sidebar.height('auto');
          $main.height('auto');

          var heightSidebar = $sidebar.outerHeight();
          var heightMain = $main.outerHeight();

          // Units that comprise the sidebar height.
          let heightUnits = 0;
          $('.js-hero-image-sidebar-unit').each(function() {
            heightUnits = heightUnits + $(this).outerHeight();
          });
          // Add padding from .page-main.
          heightUnits = heightUnits +
            parseInt($('.page-main').css('padding-top'));
          // Add main height.
          heightUnits = heightUnits + heightMain;


          if (heightSidebar < heightUnits) {
            $sidebar.height(heightUnits);
          }
          else  { // Sidebar is larger than main.
            $main.height(heightSidebar - (heightUnits - heightMain));
          }
        }
        else {
          let $smallWrapper = $('.js-hero-image-sidebar-wrapper--small');
          if ($smallWrapper.children().length === 0) {
            $sidebar.height('auto');
            $sidebar.prependTo($smallWrapper);
          }
        }
      }

      $(once('heroImageSider', '.js-hero-image-sidebar', context))
        .each(function() {
          let $sidebar = $(this);
          setHeight($sidebar);
          let r;
          $(window).on('load resize', function() {
            clearTimeout(r);
            r = setTimeout(function() {
              setHeight($sidebar);
            }, 500);
          });

        });
    },
  };
})(document, Drupal, jQuery, once);
